import { FileInfo } from './interface';

const formatDateTime = (date: Date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');

  return `${y}${m}${d}_${h}${min}${s}`;
};

function getRandomIntInclusive(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const handlePhoto = (file: any) => {
  file.idToDelete = getRandomIntInclusive(2, 30);
  file.typeInput = 'photoInput';
  return file;
};

export const handleDocument = (file: any) => {
  file.idToDelete = getRandomIntInclusive(50, 600);
  file.typeInput = 'documentInput';
  return file;
};

export const handleCam = (file: any) => {
  file.idToDelete = getRandomIntInclusive(600, 3000);
  file.typeInput = 'camInput';
  return file;
};

export async function sha256(document: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(document.toString());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}
